import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import API_BASE_URL from "../config";

const EmployeeFacilities = () => {
  const [facilities, setFacilities] = useState([]);
  const [requests, setRequests] = useState([]);
  const [facility, setFacility] = useState("");
  const [reason, setReason] = useState("");
  const [feedback, setFeedback] = useState("");
  const [policies, setPolicies] = useState([]);
  const navigate = useNavigate();

  // Fetch data
  // useEffect(() => {
  //   axios.get("http://localhost:8080/api/facilities").then((res) => setFacilities(res.data));
  //   axios.get("http://localhost:8080/api/facility-requests/my").then((res) => setRequests(res.data));
  //   axios.get("http://localhost:8080/api/facility-policies").then((res) => setPolicies(res.data));
  // }, []);

  const handleSubmitRequest = async (e) => {
    e.preventDefault();
    await axios.post(`${API_BASE_URL}/api/facility-requests`, {
      facility,
      reason,
      status: "Pending",
    });
    alert("Request submitted!");
    setFacility("");
    setReason("");
  };

  // 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token"); // or sessionStorage
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // Load Bootstrap dynamically
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    bootstrapLink.id = "timesheetgrid-bootstrap";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    iconsLink.id = "timesheetgrid-icons";
    document.head.appendChild(iconsLink);

    return () => {
      const existingBootstrap = document.getElementById("timesheetgrid-bootstrap");
      if (existingBootstrap) existingBootstrap.remove();

      const existingIcons = document.getElementById("timesheetgrid-icons");
      if (existingIcons) existingIcons.remove();
    };
  }, []);

  const handleFeedback = async (e) => {
    e.preventDefault();
    await axios.post(`${API_BASE_URL}/api/facility-feedback`, { feedback });
    alert("Feedback submitted!");
    setFeedback("");
  };

  const getBadge = (status) => {
    if (status === "Approved")
      return <span className="badge bg-success">{status}</span>;
    if (status === "Rejected")
      return <span className="badge bg-danger">{status}</span>;
    return <span className="badge bg-warning text-dark">{status}</span>;
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4 fw-bold text-primary">
        🧑‍💼 Employee Facilities
      </h3>

      {/* Available Facilities */}
      <h5>Available Facilities</h5>
      <div className="row mb-4">
        {facilities.map((f) => (
          <div key={f.id} className="col-md-4 mb-3">
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">{f.name}</h5>
                <p className="card-text">{f.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Request Form */}
      <h5>Request a Facility</h5>
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmitRequest}>
            <div className="mb-3">
              <label className="form-label">Facility</label>
              <select
                className="form-select"
                value={facility}
                onChange={(e) => setFacility(e.target.value)}
                required
              >
                <option value="">-- Select --</option>
                {facilities.map((f) => (
                  <option key={f.id} value={f.name}>
                    {f.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Reason</label>
              <textarea
                className="form-control"
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary">
              <i className="bi bi-send-fill me-1"></i> Submit Request
            </button>
          </form>
        </div>
      </div>

      {/* My Requests */}
      <h5>My Requests</h5>
      <table className="table table-bordered table-hover mb-4 align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>Facility</th>
            <th>Reason</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((r) => (
            <tr key={r.id}>
              <td>{r.facility}</td>
              <td>{r.reason}</td>
              <td>{getBadge(r.status)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Policies */}
      <h5>Company Policies</h5>
      <ul className="list-group mb-4">
        {policies.map((p) => (
          <li key={p.id} className="list-group-item">
            <strong>{p.title}:</strong> {p.description}
          </li>
        ))}
      </ul>

      {/* Feedback */}
      <h5>Provide Feedback</h5>
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleFeedback}>
            <div className="mb-3">
              <textarea
                className="form-control"
                rows={3}
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Share your feedback..."
                required
              />
            </div>
            <button type="submit" className="btn btn-success">
              <i className="bi bi-chat-dots-fill me-1"></i> Submit Feedback
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmployeeFacilities;
